// extracted by css-extract-rspack-plugin
export default {"shimmer":"_a4851146","shimmerLoadingBackground":"_3459a0ae"};